import AgentsPublicFooter from "./AgentsPublicFooter";
import RewardsPublicFooter from "./RewardsPublicFooter";

var exporDefault;

if(process.env.REACT_APP_BRAND === 'marivalagents'){
 exporDefault = AgentsPublicFooter;
}

if(process.env.REACT_APP_BRAND === 'marivalrewards'){
  exporDefault = RewardsPublicFooter;
 }

export default exporDefault;
